import framework from '../../framework';

const dateIsGreaterThan = (value, compareToValue) => {
    if (!(framework.utils.isDate(value) && framework.utils.isDate(compareToValue))) {
        return false;
    }

    return value > compareToValue;
};

// eslint-disable-next-line arrow-body-style
const makeCurrentDate = () => {
    let now = new Date();
    return new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
    );
};

const submit = function submit(store) {
    store.dispatch(
        framework.storeConstants.ActionTypes.SubmitForm,
    );
};

const confirm = function confirm(store, route, elementId) {
    const element = document.getElementById(elementId);

    // eslint-disable-next-line no-underscore-dangle
    let dialogComponent = element.__vue__;
    if (dialogComponent.name && dialogComponent.name.includes('transition')) {
        dialogComponent = dialogComponent.$parent;
    }
    return dialogComponent.confirm();
};

/***********************************************************************
 * Custom Validations
 * If the input is invalid, return a string.
 * If valid, return an empty string
 ***********************************************************************/

const dateIsGreaterThanToday = function dateIsGreaterThanToday(store) {
    let node = store.getters.getManifestNode(this.controlId);
    if (framework.manifest.nodeHasValue(node)) {
        let dateVal = new Date(Date.parse(node.values[0].value));
        if (dateIsGreaterThan(dateVal, makeCurrentDate())) {
            return `This date cannot be after today's date`;
        }
    }

    return '';
};

export {
    submit,
    confirm,
    dateIsGreaterThanToday,
};


// WEBPACK FOOTER //
// ./source/framework/interactions/interactions.js